import React from 'react';
import PropTypes from 'prop-types';

import { numberToPercentage } from '../../../../utils/formatter';

const MonetizationLegend = ({ data }) => (
  <table className="table table-lg table-bordered-x mx-auto publisher_page_monetization__legend">
    <tbody>
      <tr>
        <td className="p-y-sm">
          <div className="d-flex flex-items-xxs-middle text-xs text-nowrap">
            <i className="hicon-checkbox m-r-xxs publisher_page_monetization__legend_iap_marker" />
            <span>In-App Purchases</span>
          </div>
        </td>
        <td className="text-lg text-nowrap p-y-sm">{data.series?.[0]?.value}</td>
        <td className="text-xs text-quiet p-y-sm">
          ({numberToPercentage(data.iap_percentage * 100)})
        </td>
      </tr>
      <tr>
        <td className="b-b-0 p-y-sm">
          <div className="d-flex align-items-center text-xs text-nowrap">
            <i className="hicon-checkbox m-r-xxs text-green" />
            <span>Paid</span>
          </div>
        </td>
        <td className="text-lg text-nowrap b-b-0 p-y-sm">{data.series?.[1]?.value}</td>
        <td className="text-xs text-quiet b-b-0 p-y-sm">
          ({numberToPercentage(data.downloads_percentage * 100)})
        </td>
      </tr>
    </tbody>
  </table>
);

MonetizationLegend.propTypes = {
  data: PropTypes.shape({
    iap_revenue: PropTypes.number,
    download_revenue: PropTypes.number,
    iap_percentage: PropTypes.number,
    downloads_percentage: PropTypes.number,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default MonetizationLegend;
